import { PlusCircleOutlined } from "@ant-design/icons";
import { Image, Upload } from "antd";
import { Toast } from "antd-mobile";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { getText } from "../../../../utils/util";
import { imgs } from "./imgs";
import "./index.css";
import { useFetch } from "@/lib/fetch-tools";
import { apiUserInfo } from "@/api/acendex/user";

export default function CenterPage({ sendMsg, listData }) {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const messagesRef = useRef(null);
  const { t: translate } = useTranslation();
  const [length, setLength] = useState(0);
  const { data } = useFetch(apiUserInfo);
  const userInfo = data?.data ?? null;
  //上传
  const handleChange = (info) => {
    if (userInfo.black === 1) {
      console.log("black");
      return;
    }
    if (info.file.status === "done") {
      if (info.file.response && info.file.response.ok) {
        Toast.show({
          content: `${info.file.name} ${translate(getText("上傳成功"))}`,
        });
        const data = info.file.response;
        sendMsg(`image:${data.data}`);
      } else {
        Toast.show({ content: translate(getText(`上传失败`)) });
      }
    } else if (info.file.status === "error") {
      Toast.show({ content: translate(getText(`上传失败`)) });
    }
  };
  //自动滚动到底部
  const scrollDiv = () => {
    if (messagesRef.current) {
      // 使用 scrollHeight 属性来获取整个滚动内容的高度
      messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }
  };
  //加载节点
  const getNodes = () => {
    const nodes = [];
    for (const data of listData) {
      const node =
        data.type === 1 ? (
          <div className="servererCenterInfo-22">
            <div className="servererCenterInfo-23">
              <div className="servererCenterInfo-24">
                <img
                  src="/aichat/80b12be3-46df-4489-aa71-4bf784752950.jpg"
                  className="servererCenterInfo-25"
                />
              </div>
              <div className="servererCenterInfo-26">
                <div className="servererCenterInfo-27">
                  <div className="servererCenterInfo-28">
                    {data.content.startsWith("image:") ? (
                      <div
                        style={{
                          float: "right",
                          padding: "5px",
                        }}
                      >
                        <Image
                          width="100px"
                          height="100px"
                          src={
                            imageConfig.baseImageUrl +
                            data.content.replace("image:", "")
                          }
                          fallback={imgs.fallback}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          padding: "2px 10px",
                          borderRadius: "5px",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {data.content}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="servererCenterInfo-30">
            <div className="servererCenterInfo-31">
              <div className="servererCenterInfo-32">
                <div className="servererCenterInfo-33">
                  <div className="servererCenterInfo-34">
                    {data.content.startsWith("image:") ? (
                      <div
                        style={{
                          float: "right",
                          padding: "5px",
                        }}
                      >
                        <Image
                          width="100px"
                          height="100px"
                          src={
                            imageConfig.baseImageUrl +
                            data.content.replace("image:", "")
                          }
                          fallback={imgs.fallback}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          padding: "2px 10px",
                          borderRadius: "5px",
                          whiteSpace: "pre-line",
                        }}
                      >
                        {data.content}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      nodes.push(node);
    }
    //滚动
    if (length < listData.length) {
      setTimeout(() => {
        scrollDiv();
      }, 1000);
      setLength(listData.length);
    }
    return nodes;
  };

  return (
    <div className="flex flex-col">
      <div className="flex-1 flex flex-col">
        {/* 头部客服信息 */}
        <div className="flex items-center p-4 bg-neutral-800 border-b border-neutral-700">
          <div className="w-10 h-10 rounded-full overflow-hidden mr-3">
            <img
              src="/aichat/80b12be3-46df-4489-aa71-4bf784752950.jpg"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex flex-col">
            <span className="text-neutral-50 font-medium">Lorna</span>
            <span className="text-sm text-neutral-400">
              {translate(getText("online service"))}
            </span>
          </div>
        </div>

        {/* 提示文本 */}
        <div className="px-4 py-3 text-sm text-neutral-400 bg-neutral-800/50">
          {translate(getText("请直接提交您的问题,等待客服回复即可"))}
        </div>

        {/* 聊天消息列表 */}
        <div className="flex-1 overflow-y-auto p-4" ref={messagesRef}>
          {listData.map((data, index) =>
            data.type === 2 ? (
              // 用户消息
              <div key={index} className="flex justify-end mb-4">
                <div className="max-w-[80%] bg-primary rounded-lg overflow-hidden">
                  {data.content.startsWith("image:") ? (
                    <Image
                      width={200}
                      className="rounded-lg"
                      src={
                        imageConfig.baseImageUrl +
                        data.content.replace("image:", "")
                      }
                      fallback={imgs.fallback}
                    />
                  ) : (
                    <div className="p-3 text-neutral-900 break-words whitespace-pre-line">
                      {data.content}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              // 客服消息
              <div key={index} className="flex mb-4">
                <div className="w-8 h-8 rounded-full overflow-hidden mr-2">
                  <img
                    src="/aichat/80b12be3-46df-4489-aa71-4bf784752950.jpg"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="max-w-[80%] bg-neutral-800 rounded-lg overflow-hidden">
                  {data.content.startsWith("image:") ? (
                    <Image
                      width={200}
                      className="rounded-lg"
                      src={
                        imageConfig.baseImageUrl +
                        data.content.replace("image:", "")
                      }
                      fallback={imgs.fallback}
                    />
                  ) : (
                    <div className="p-3 text-neutral-50 break-words whitespace-pre-line">
                      {data.content}
                    </div>
                  )}
                </div>
              </div>
            )
          )}
        </div>

        {/* 底部输入区域 */}
        <div className="p-4 bg-neutral-800 border-t border-neutral-700">
          <div className="flex items-end gap-2">
            <div className="flex-1 bg-neutral-700 rounded-lg">
              <textarea
                className="w-full min-h-[80px] p-3 bg-transparent text-neutral-50 placeholder-neutral-400 resize-none focus:outline-none"
                placeholder="Message"
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </div>
            <div className="flex gap-2">
              <Upload
                name="file"
                accept="image/*"
                showUploadList={false}
                action={imageConfig.uploadUrl}
                onChange={handleChange}
              >
                <button className="p-2 bg-neutral-700 hover:bg-neutral-600 rounded-lg transition-colors">
                  <PlusCircleOutlined className="text-xl text-neutral-300" />
                </button>
              </Upload>
              <button
                className="p-2 bg-primary hover:bg-primary-light rounded-lg transition-colors"
                onClick={() => {
                  if (userInfo.black === 1) {
                    console.log("black");
                    return;
                  }
                  setContent("");
                  sendMsg(content);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
